import { defineMessages } from '@transcend-io/internationalization';

export const sidebarMobileMessages = defineMessages(
  'privacy-center.components.SidebarMobile.sidebarMobile',
  {
    hideMenu: {
      defaultMessage: 'Hide Menu',
    },
    showMenu: {
      defaultMessage: 'Show Menu',
    },
  },
);
